module.exports = __webpack_public_path__ + "10e812871cd74e7809d4df669f632aad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/columbia_university_2023_chart.png
// module id = 1656
// module chunks = 0